import { animate, keyframes, style, transition, trigger } from '@angular/animations';

export const bounce = trigger('bounce', [
  transition('* => *', [
    animate('1s', keyframes ( [
      style({ transform: 'scale(1,1) translateY(0)' }),
      style({ transform: 'scale(1.1, 0.9) translateY(0)' }),
      style({ transform: 'scale(0.9, 1.1) translateY(-20px)' }),
      style({ transform: 'scale(1.05, 0.95) translateY(0)' }),
      style({ transform: 'scale(1,1) translateY(-7px)' }),
      style({ transform: 'scale(1,1) translateY(0)' }),
    ]))
  ])
]);
